import React from "react";
import { Result, Button } from "antd";
import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div
      style={{
        height: "85vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Result
        status="404"
        title="404 - Not Found"
        subTitle="The page you are looking for does not exist."
        extra={
          <Button type="primary">
            <Link to="/">Go Home</Link>
          </Button>
        }
      />
    </div>
  );
};

export default NotFoundPage;
